import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query'
import { useSetAtom } from 'jotai'
import { useCallback } from 'react'
import { toast } from '~components/ui/toast'
import Pet from '~models/pet'
import PetRepository from '~repositories/impl/pet-repository'
import loadingAtom from '~store/loading'
import Mixpanel from '~utils/mixpanel'
import { APP_QUERY_KEYS } from './query-keys'

const useCreatePet = (options?: UseMutationOptions<Pet.Level1, Error, Pet.Level1>) => {
  const queryClient = useQueryClient()
  const setLoading = useSetAtom(loadingAtom)

  const { mutate } = useMutation({
    mutationFn: PetRepository.createPet,
    onSuccess: (res, req, ctx) => {
      options?.onSuccess?.(res, req, ctx)
      queryClient.invalidateQueries({
        queryKey: APP_QUERY_KEYS.myPets,
      })
      Mixpanel.logEvent('pet: create_completed')
      toast.open({
        type: 'success',
        message: `Added ${res.name} successfully.`,
      })
    },
    onSettled: () => {
      setLoading(false)
    },
  })

  const createNewPet = useCallback(
    (newPet: Pet.Level1) => {
      mutate(newPet)
    },
    [mutate]
  )

  return createNewPet
}

export default useCreatePet
